import {useEffect, useState} from "react";
import comments_api from "../api/protected/comments"
import edit from "../assets/edit-pencil.svg"
import del from "../assets/delete-bin.svg"
import GenericDialog from "./GenericDialog";
import {useNavigate} from "react-router-dom";
import SubscriptionNeededPopup from "./SubscriptionNeededPopup";

const CoachCommentaryContainer = (props) => {

    const navigate = useNavigate()
    const [newComment, setNewComment] = useState("")
    const [editedComment, setEditedComment] = useState("")
    const [editCommentID, setEditCommentID] = useState(0)
    const [comments, setComments] = useState([])
    const [showEditDialogue, setShowEditDialogue] = useState(false)
    const [showDeleteDialogue, setShowDeleteDialogue] = useState(false)
    const context_id = props.context_id
    const section_id = props.section_id
    const generatingReport = props.generatingReport
    const subscription = props.subscription
    const [showBronzeSubscriptionPopup, setShowBronzeSubscriptionPopup] = useState(false)
    const [showSilverSubscriptionPopup, setShowSilverSubscriptionPopup] = useState(false)
    const subscriptionPopupButtons = [{"text":"OK", "id": "1"}, {"text":"Upgrade", "id": "2"}];

    useEffect(() => {
        if(!context_id || !section_id) return;
        getComments()
    }, [context_id, section_id]);

    const getComments = () => {
        if (props.demo) return;
        let response = comments_api.getComments(context_id, section_id);
        response.then(response => {
            setComments(response.data)
        }).catch(err => console.log(err))
    }

    const postComment = (ev) => {
        if(!ev || !newComment) return;
        if(subscription < 1) {
            setShowBronzeSubscriptionPopup(true)
            return
        }
        let response = comments_api.newComment(context_id, section_id, newComment);
        response.then(() => {
            setNewComment("")
            getComments()
        }).catch(err => {
            if (err.response.request.status === 402) {
                setShowSilverSubscriptionPopup(true)
            }
            console.log(err)
        })
    }

    const deleteComment = (ev) => {
        if(!ev || !editCommentID) return;
        let response = comments_api.deleteComment(editCommentID);
        response.then(() => getComments()).catch(err => console.log(err))
        setShowDeleteDialogue(false)
        setEditCommentID(0)
    }

    const editComment = (ev) => {
        if(!ev || !editCommentID) return;
        let response = comments_api.editComment(editCommentID, editedComment);
        response.then(() => getComments()).catch(err => console.log(err))
        setShowEditDialogue(false);
        setEditedComment("")
        setEditCommentID(0)
    }

    const handleEditClick = (ev, comment, id) => {
        if(!ev) return;
        setShowEditDialogue(true);
        setEditedComment(comment)
        setEditCommentID(id)
    }

    const handleDeleteClick = (ev, id) => {
        if(!ev) return;
        setShowDeleteDialogue(true)
        setEditCommentID(id)
    }

    const closeEditDialogue = (ev) => {
        if(!ev) return;
        setShowEditDialogue(false);
    }

    const closeDeleteDialogue = (ev) => {
        if(!ev) return;
        setShowDeleteDialogue(false);
    }

    const handleSubscriptionPopupResult = (res) => {
        if(!res) return;
        if (res === "1") {
            setShowSilverSubscriptionPopup(false)
        } else {
            navigate("/pricing-plans")
        }
    }

    return (
        <>
            <div className="coach-commentary-container"
                 style={{display: (generatingReport && !comments.length) || props.demo ? "none" : null}}>
                {subscription < 1 && (
                    <div
                        className="coach-commentary-overlay"
                        onClick={() => setShowBronzeSubscriptionPopup(true)}
                    ></div>
                )}
                {comments.map((comment, idx) => {
                    return (
                        <div className="coach-commentary-comment-container" key={idx}>
                            <div className="comment-comment regular">{comment.comment}</div>
                            <div className="comment-details-container">
                                {comment.editable ?
                                    <div className="comment-controls" style={{opacity: generatingReport ? 0 : null}}>
                                        <div className="comment-button"
                                             onClick={ev => handleEditClick(ev, comment.comment, comment.id)}>
                                            <img src={edit} alt="Edit Comment"/>
                                        </div>
                                        <div className="comment-button"
                                             onClick={ev => handleDeleteClick(ev, comment.id)}>
                                            <img src={del} alt="Delete Comment"/>
                                        </div>
                                    </div> : <div className="spacer"/>
                                }
                                <div className="comment-name bold">{comment.author}</div>
                            </div>
                        </div>
                    )
                })}
                <div className="coach-commentary-add-comment-container"
                     style={{display: generatingReport ? "none" : null}}>
                    <div className="coach-commentary-comment-input regular">
                        <input type="text" value={newComment} placeholder="Add a comment"
                               onChange={ev => setNewComment(ev.target.value)} maxLength={1024}/>
                        <div className="coach-commentary-comment-text-length-indicator regular">
                            {newComment.length}/1024
                        </div>
                    </div>
                    <div className="coach-commentary-post-comment-button bold" onClick={postComment}>ADD COMMENT</div>
                </div>
            </div>
            {showEditDialogue ?
                <>
                    <div className="page-mask" onClick={closeEditDialogue}/>
                    <div className="coach-commentary-edit-comment-container">
                        <div className="coach-commentary-comment-input regular">
                            <input type="text" value={editedComment} placeholder="Edit comment"
                                   onChange={ev => setEditedComment(ev.target.value)}/>
                        </div>
                        <div className="coach-commentary-post-comment-button grey bold" onClick={closeEditDialogue}>
                            CANCEL
                        </div>
                        <div className="coach-commentary-post-comment-button bold" onClick={editComment}>
                            EDIT COMMENT
                        </div>
                    </div>
                </>
                : null
            }
            {showDeleteDialogue ?
                <>
                    <div className="page-mask" onClick={closeDeleteDialogue}/>
                    <div className="coach-commentary-delete-comment-container">
                        <div className="comment-delete-dialogue-text regular">
                            Are you sure you want to delete this comment?
                        </div>
                        <div className="comment-delete-dialogue-controls">
                            <div className="coach-commentary-post-comment-button grey bold delete" onClick={closeDeleteDialogue}>
                                CANCEL
                            </div>
                            <div className="coach-commentary-post-comment-button bold delete red" onClick={deleteComment}>
                                DELETE
                            </div>
                        </div>
                    </div>
                </>
                : null
            }
            {showSilverSubscriptionPopup ?
                <GenericDialog title="Invalid Subscription"
                               text="You need a SILVER subscription or higher to add comments. Please upgrade if you wish to use this feature"
                               buttons={subscriptionPopupButtons}
                               result={handleSubscriptionPopupResult.bind(this)}/>
                : null
            }
            {showBronzeSubscriptionPopup && (
                <SubscriptionNeededPopup
                    onClose={() => setShowBronzeSubscriptionPopup(false)}
                />
            )}
        </>
    )
}

export default CoachCommentaryContainer